import { render } from "./QuestionsQuizSimulado.vue?vue&type=template&id=f04552e2&translate=no"
import script from "./QuestionsQuizSimulado.vue?vue&type=script&lang=js"
export * from "./QuestionsQuizSimulado.vue?vue&type=script&lang=js"

import "./QuestionsQuizSimulado.vue?vue&type=style&index=0&id=f04552e2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__